import React from "react";
import "./styles/Questions.css";
import QuestionBox from "../components/QuestionBox";
import { v4 as uuidv4 } from "uuid";
import { motion } from "framer-motion";
import { useInView } from 'react-intersection-observer'

const Questions = ({ faqSectionRef, faqData }) => {
  // Intersect Observer ( Checks if component is in view ) 
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  return (
    <div className="faq-section" ref={faqSectionRef}>
      <div>
        <h2 className="tilted-text">Most of</h2>
        <h2 className="header"><span style={{ textDecoration: 'line-through' }}>All</span> Your Questions Answered</h2>
      </div>
      <motion.div
        ref={ref}
        initial={{ opacity: 0, scale: 0.95 }}
        animate={inView ? { opacity: 1, scale: 1 } : {}}
        transition={{ duration: 0.3, ease: 'easeOut' }}
        className="faq-container"
      >
        <div className="content">
          <div className="section">
            {faqData
              .filter((_, index) => index % 2 === 0)
              .map((faq, index) => (
                <QuestionBox
                  key={faq.id}
                  questionContent={{
                    question: faq.question,
                    answer: faq.answer
                  }}
                />
              ))}
          </div>
          <div className="section">
            {faqData
              .filter((_, index) => index % 2 !== 0)
              .map((faq, index) => (
                <QuestionBox
                  key={faq.id}
                  questionContent={{
                    question: faq.question,
                    answer: faq.answer
                  }}
                />
              ))}
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default Questions;
